import { EMPTY_STRING } from "shared/constants";
import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  supplierID: EMPTY_STRING,
  avb: null,
  epd: null,
  msi: null,
  entries: [],
};
export const vatOptions: OptionType[] = [
  { key: 0, value: "Excluded" },
  { key: 1, value: "Included" },
];
